import { SupplyDemand } from '../../components/SupplyDemand';
import { EChartTypes, ValuationChartsWidget } from '@cian/valuation-web-charts-widget';
import { sub } from 'date-fns';
import { useGetSupplyDemandDiff } from './hooks';
import { SupplyDemandFooter } from '../../components/SupplyDemandFooter';
import { ChartInfo } from '../../components/ChartInfo';
import { FC, useCallback, useMemo, useState } from 'react';
import { ILogger } from '@cian/logger';
import { IGetSupplyDemandResponseSchema } from 'shared/repositories/valuation-offer-history/entities/market_trand/GetSupplyDemandResponseSchema';
import { today } from '../../utils/date';
import { useDeviceType } from '@cian/ui-kit';

interface ISupplyDemandContainerProps extends Required<IGetSupplyDemandResponseSchema> {
  logger: ILogger;
}

export const SupplyDemandContainer: FC<ISupplyDemandContainerProps> = ({
  logger,
  supplyTrand: supplyTrend,
  demandTrand: demandTrend,
  demandDiffTrand,
  supplyDiff,
  demandDiff,
  supplyDiffTrand,
  marketType,
  marketTypeDescription,
}) => {
  const deviceType = useDeviceType();
  const [isInfoOpen, setInfoState] = useState(false);

  const handleOpenInfo = useCallback(() => {
    setInfoState(true);
  }, []);

  const { supplyDiffData, demandDiffData } = useGetSupplyDemandDiff({
    demandDiffTrand,
    demandDiff,
    supplyDiffTrand,
    supplyDiff,
  });

  const chartInfoText = useMemo(
    () => ({
      magentaText: demandTrend.length ? 'Спрос' : null,
      blueText: supplyTrend.length ? 'Предложение' : null,
    }),
    [demandTrend, supplyTrend],
  );

  return (
    <div>
      <SupplyDemand
        marketType={marketType}
        supplyDiffData={supplyDiffData}
        demandDiffData={demandDiffData}
        isInfoOpen={isInfoOpen}
        handleOpenInfo={handleOpenInfo}
        marketTypeDescription={marketTypeDescription}
        isDesktop={deviceType === 'desktop'}
      />
      <ChartInfo {...chartInfoText} />
      <ValuationChartsWidget
        key={supplyDiff}
        data={{
          dateMin: +sub(today(), { years: 1 }),
          dateMax: today(),
          supplyTrend,
          demandTrend,
          xScale: 'month',
        }}
        logger={logger}
        type={EChartTypes.SupplyDemand}
      />
      <SupplyDemandFooter />
    </div>
  );
};
